import { Component } from '@angular/core';

@Component({
  selector: 'app-cookie-policy',
  templateUrl: './cookie-policy.component.html',
  styleUrls: ['./cookie-policy.component.scss']
})
export class CookiePolicyComponent {
  siteOwner = 'Alessandro Bompadre';
  lastUpdated = '29 marzo 2026';
  // Indicate current usage: we use localStorage for preferences, no tracking cookies added by this app
  usesCookies(): boolean {
    return false;
  }
}
